import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {OrbitSwiperComponent} from '../orbit-swiper/orbit-swiper.component';
import {IVideoListViewModel} from "../../services/arenas/models/lists/video-list/video-list-view-model.interface";


interface VideoListComponentProps {
    viewModel: IVideoListViewModel;
    listPosition: number;
}

export const VideoListComponent = observer(class VideoListComponent extends OrbitComponent<VideoListComponentProps> {

    // For static video list we need to know the final gametype(from UI perspective)
    // For the final gametype, once video finishes, we don't auto swipe to the next one(= first one).
    private _getLastGameType(): number {
        let gameTypes = this.props.viewModel.gameTypes;
        let index = this.services.mediaQuery.xlAndAbove ? 0 : (gameTypes.length - 1);
        return gameTypes[index];
    }

    private _onGameBringInCentralView = (gameIndex:  number) => {
        this.props.viewModel.setCurrentGameIndex(gameIndex);
    }

    render() {
        const viewModel = this.props.viewModel;
        return (
            <OrbitSwiperComponent
                viewModel={viewModel}
                listPosition={this.props.listPosition}
                lastGameType={this._getLastGameType()}
                onGameBringInCentralView={this._onGameBringInCentralView}
            />
        );
    }
});
